import { useEnsName } from 'wagmi';

import { Warrior } from '~/../api/common.types';
import Diamond from '~/components/common/Diamond';
import { useGameContext } from '~/contextProviders/GameContextProvider';
import {
  calculateAttackBonus,
  getAttackByBattle,
  getCurrentWarrior,
  isWarriorNamed,
  shortenedAddress,
} from '~/utils/utils';

export default function WarriorDetails({
  facing,
  warrior,
  active,
  victor,
  attackPreview,
}: {
  facing: string;
  warrior: Warrior;
  active: boolean;
  victor: number | undefined;
  attackPreview?;
  lifeAndDeathRoundOpponent?: boolean | undefined;
}) {
  {
    /* eslint-disable camelcase */
  }
  const warriorBattle = getCurrentWarrior(warrior);
  const { data: ensName } = useEnsName({
    address: warrior.owner as `0x${string}`,
  });
  const { battle, tournamentParam } = useGameContext();

  const addressFormatted = ensName ?
    ensName :
    shortenedAddress(warrior.owner || '');
  const character = warrior.warrior_json.attributes.find(
    ({ trait_type }) => trait_type === 'Character'
  )?.value;
  const characterKey = character?.toLowerCase().replaceAll(' ', '-');

  let attackBonus;
  let attackByBattle;

  if (attackPreview || warrior.set_attack) {
    attackBonus = calculateAttackBonus(
      attackPreview || warrior.set_attack,
      warrior,
      tournamentParam,
      battle
    );
  } else if (victor) {
    attackByBattle = getAttackByBattle(
      warrior,
      tournamentParam,
      battle
    );
    attackBonus = calculateAttackBonus(
      attackByBattle,
      warrior,
      tournamentParam,
      battle
    );
  }
  const chosenAttackBonus: string = attackPreview || warrior.set_attack || attackByBattle;

  const warriorName = isWarriorNamed(
    warrior.warrior_json.name,
    warrior.warrior_id
  ) ?
    warrior.warrior_json.name :
    `Peacefall #${warrior.warrior_id}`;

  return (
    <div
      className={`warrior__details warrior__details--${facing}  warrior__details--${character?.toLowerCase()} warrior__active--${active}`}
    >
      {victor && victor !== warrior.warrior_id && (
        <img
          src={
            warriorBattle.dead ?
              warriorBattle.images.dead :
              warriorBattle.images.stunned
          }
          alt="stars"
          className="warrior__details__stars"
        />
      )}
      {/* almost identical and should be cleaned up, quickly built. saves an image request */}
      <img
        src={warriorBattle.dead ? warriorBattle.images.dead : warriorBattle.images.active}
        alt={warriorBattle.name}
        className={`warrior__image warrior__image--active ${
          victor === warrior.warrior_id && 'warrior__image--victor'
        } ${
          victor !== undefined &&
          victor !== warrior.warrior_id &&
          'warrior__image--loser'
        } warrior__image--${facing} warrior__image--${characterKey}`}
      />
      <img
        src={warriorBattle.dead ? warriorBattle.images.dead : warriorBattle.images.notActive}
        alt={warriorBattle.name}
        className={`warrior__image warrior__image--not-active ${
          victor === warrior.warrior_id && 'warrior__image--victor'
        } ${
          victor !== undefined &&
          victor !== warrior.warrior_id &&
          'warrior__image--loser'
        } warrior__image--${facing} warrior__image--${characterKey}`}
      />
      <h3 className="warrior__details--class">{addressFormatted}</h3>
      <h3 className="warrior__details--class"><a className="link" href={`/warrior/${warrior.warrior_id}`} target="_blank" rel="noopener noreferrer">{warriorName}</a></h3>
      {warriorBattle.dead &&
        <h3 className="warrior__details--class">Status: 💀</h3>
      }
      <h3 className="warrior__details--score">
        L{warriorBattle.level}
        <Diamond /> HP {warriorBattle.hp}
        {attackBonus > 0 && chosenAttackBonus && (
          <span
            className="warrior__details--attack-bonus"
            data-id={chosenAttackBonus.toLowerCase()}
          >
            + {attackBonus}
          </span>
        )}
      </h3>
      <h3
        className={`warrior__details--syndicate warrior__details--syndicate-${warriorBattle.syndicate?.toLowerCase()}`}
      >
        <span>{warriorBattle.syndicate}</span>
      </h3>
    </div>
  );
}
